module.exports = __webpack_public_path__ + "static/media/carinsurance.dfeba4f2.png";